import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cancelmessage',
  templateUrl: './cancelmessage.component.html',
  styleUrls: ['./cancelmessage.component.css']
})
export class CancelmessageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
